import { Flex, Heading } from '@buffer-mono/popcorn'

import { CleanQueueAction } from './components/CleanQueueAction'
import { DeleteDraftsAction } from './components/DeleteDraftsAction'
import { EmptyQueueAction } from './components/EmptyQueueAction'
import { PauseQueueAction } from './components/PauseQueueAction'
import { ShuffleQueueAction } from './components/ShuffleQueueAction'

import styles from './QueueActions.module.css'

import type { JSX } from 'react'

const QueueActions = (): JSX.Element => (
  <Flex
    direction="column"
    gap="lg"
    className={styles.queueActionsWrapper}
    data-testid="queue-actions-wrapper"
  >
    <Heading size="small" as="h3">
      Queue Actions
    </Heading>
    <PauseQueueAction />
    <ShuffleQueueAction />
    <CleanQueueAction />
    <DeleteDraftsAction />
    <EmptyQueueAction />
  </Flex>
)

export { QueueActions }
